import companyLogo from './kedle.svg';
export const logo = companyLogo;
export const companyName = "科德智能";